import { render, staticRenderFns } from "./OrganizationTabFederationUsers.vue?vue&type=template&id=5f118508&scoped=true"
import script from "./OrganizationTabFederationUsers.vue?vue&type=script&lang=js"
export * from "./OrganizationTabFederationUsers.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTabFederationUsers.vue?vue&type=style&index=0&id=5f118508&prod&scoped=true&lang=css"
import style1 from "./OrganizationTabFederationUsers.vue?vue&type=style&index=1&id=5f118508&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f118508",
  null
  
)

export default component.exports